import React from 'react';
import _get from 'lodash.get';

const errorCodesContainingMessageList = [
    '9003',
];

/**
 * Generate error config by server error.
 * @param {Object} errors server errors.
 * @param {String} [errors.9003.message] incorrect card details error message.
 * @param {String} bookmakerFeed bookmaker name.
 * @return {Object} client top up error message.
 */
export default function topUpErrors(errors, bookmakerFeed = '') {
    const errorCodes = Object.keys(errors);
    const errorCode = errorCodes.pop();

    if (bookmakerFeed === 'BET365') {
        const errorMessageDetail = _get(errors, `[${errorCode}]`, '');

        const errExMsg = 'RacingPost\\BetSlip\\Http\\Exception\\UnauthorisedException: ';
        const errPaymentAuthMsg = 'Payment authentication required. ';
        const errGoBackMsg = 'Please go to bet365.com to attempt your deposit.';
        const targetErrMsg = errExMsg + errPaymentAuthMsg + errGoBackMsg;

        const isError401 = errors.code ? errors.code.toLowerCase() === 'unauthorized' : false;

        if ((errorMessageDetail === targetErrMsg) || isError401) {
            return (
                <span>
                    Payment authentication required.
                    Please go to <a rel="noopener noreferrer" target="_blank" href="https://www.bet365.com/#/HO/">bet365.com</a>&nbsp;
                    to attempt your deposit.
                </span>
            );
        }
    }

    if (errorCodesContainingMessageList.indexOf(errorCode) !== -1) {
        return _get(errors, `[${errorCode}].message`, '');
    }

    return 'Payment authorisation failed. Please check your details and try again';
}



// WEBPACK FOOTER //
// /src/js/common/topUp/components/topUpErrors.jsx